import styles from '../style.module.scss';
import skeleton from './styles.module.scss';

export default function UserBonusCheckpointsV2RenderStepSkeleton() {
  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.container__indicator} `}>
        <div className={styles.container__item}>
          <p />
        </div>
      </div>
      <div className={styles.container__column}>
        <div className={styles.container__column__label}>
          <div className={skeleton.label} />
        </div>
        <div className={styles.container__column__description}>
          <div className={skeleton.description} />
        </div>
      </div>
    </div>
  );
}
